import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Select } from 'components/fields'
import { Button, Col, Module, Row } from 'components/misc'
import { Form, Title } from 'components/layout'
import { FormattedMessage } from 'react-intl'
import { apiCodeLists, apiParticipants } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { DeleteParticipantAwardApprovalModal } from 'components/modals'
import { get } from 'lodash'
import styles from './delete-participant-award.styl'
import { connect } from 'react-redux'

@apiCodeLists(['awardLevelTypes'])
@apiParticipants({ form: 'formDeleteParticipantAward' })
@connect(
    state => ({
        deleteAwardState: state.api.participants.deleteAward,
        participant: state.api.participants.detail
    }), {}
)
@form({
    form: 'formDeleteParticipantAward',
    disableHook: true
})
class DeleteParticipantAward extends Component {
    static propTypes = {
        deleteAward: PropTypes.func,
        deleteParticipantAwardValues: PropTypes.object,
        modal: PropTypes.object,
        deleteAwardState: PropTypes.object,
        notification: PropTypes.func,
        logError: PropTypes.func,
        codeLists: PropTypes.object.isRequired,
        onGetParticipant: PropTypes.func,
        participant: PropTypes.object
    }

    componentWillReceiveProps(nextProps) {
        const pidOld = get(this.props.deleteParticipantAwardValues, 'participantId')

        const pidNew = get(nextProps.deleteParticipantAwardValues, 'participantId')

        if(pidOld !== pidNew){
            this.props.onGetParticipant(pidNew)
        }
    }

    handleSubmit(event) {
        this.props.modal('delete-participant-award-approval-modal')
        event.preventDefault()
    }

    handleOnApprove() {
        const participantId = get(this.props.deleteParticipantAwardValues, 'participantId')

        const awardLevel = get(this.props.deleteParticipantAwardValues, 'awardLevel')

        this.props.deleteAward(participantId, awardLevel).then(() => {
            this.props.modal(null)
        }).then(this.handleDeleteAwardSuccess)
            .catch(this.handleError)
    }

    handleDeleteAwardSuccess = () => {
        this.props.notification('Award was deleted.', {
            status: 'success',
            intlKey: 'notifications.award_was_deleted'
        })
        this.props.modal(null)
    }

    handleError = err => {
        this.props.logError(err)
        this.props.modal(null)
        if (err && err.body) {
            console.debug('error', err.body && err.body.userMessage)
            this.props.notification(err.body.userMessage || 'Error', 'error')
        }
    }

    render() {
        const participantId = get(this.props.deleteParticipantAwardValues, 'participantId')

        const participantName = get(this.props.participant, 'name')

        const awardLevel = get(this.props.deleteParticipantAwardValues, 'awardLevel')

        const { codeLists, deleteAwardState: { loading } = {} } = this.props

        return (
            <div className={styles.module_wrapper}>
                <Module verticallyNarrow primary>
                    <div className={styles.wrapper}>
                        <Row alignItems="center" gutters inner paddingTop>
                            <Form>
                                <Title h1>
                                    <FormattedMessage
                                        id="moduleTitle.award_participant_delete"
                                        defaultMessage="Delete participant award"
                                    />
                                </Title>
                                <Select
                                    label="Award level to delete"
                                    name="awardLevel"
                                    intlKey="label.award_to_delete"
                                    options={codeLists.awardLevelTypes.list}
                                />
                                <Col flex="0 1 200px" alignSelf="center">
                                    <Input
                                        label="Participant ID"
                                        intlKey="label.award_delete_participant_id"
                                        name="participantId"
                                        type="number"
                                        maxLength={8}
                                    />
                                </Col>

                                <Button onClick={event => this.handleSubmit(event)}>
                                    <FormattedMessage id="button.delete_award" defaultMessage="Delete Award" />
                                </Button>

                            </Form>
                            <DeleteParticipantAwardApprovalModal
                                modalId="delete-participant-award-approval-modal"
                                isLoading={loading}
                                participantId={participantId}
                                participantName={participantName}
                                awardLevel={awardLevel}
                                onApprove={() => this.handleOnApprove()}
                            />
                        </Row>
                    </div>
                </Module>
            </div>
        )
    }
}

export default DeleteParticipantAward
